import React, { useState } from 'react'
import { useParams } from 'react-router'
import CustomViewForm from '../components/CustomViewForm'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import LeadView from '../components/version-4/viewForms/LeadFormView'
import { useFeatures } from '../hooks/Features/useFeatures'
import { formatDate, formatNumber, formatPercentage, ROUTES } from '../shared/constants'

function ViewLead() {
  const { getLead, lead } = useFeatures()
  const params = useParams()

  const [data, setData] = useState([])

  React.useEffect(() => {
    getLead({ leadId: params.leadId })
  }, [params.leadId])

  React.useEffect(() => {
    if (lead) {
      setData([
        { label: 'Customer Name', data: lead.customer && lead.customer.name },
        { label: 'Agent', data: lead.addedBy && `${lead.addedBy.firstName} ${lead.addedBy.lastName}` },
        { label: 'Type', data: lead.status && lead.status.name },
        { label: 'Lead Amount', data: formatNumber(lead.leadAmount) },
        { label: 'Discount Type', data: lead.discountType },
        { label: 'Discount', data: lead.discountType === 'AMOUNT' ? formatNumber(lead.totalDiscount) : `${lead.totalDiscount} %` },
        { label: 'Quote Number', data: lead.quoteNumber },
        { label: 'Follow Up', data: formatDate(lead.followUp) },
        { label: 'Validity', data: formatDate(lead.validity) },
        {
          label: 'Quantity / SKU',
          data: lead.wishlist.map((item) => ({
            ...item,
            sku: item.productId.sku,
            price: formatNumber(item.dealerPrice),
          })),
          type: 'ARRAY',
          value: 'quantity',
          extraValues: ['sku'],
        },
      ])
    }
  }, [lead])

  return (
    <Layout heading="Lead" heading2="Info" url1={ROUTES.LEADS} none>
      {lead ? <HeaderTabLayout url={`/edit-lead/${params.leadId}`} heading="Lead" content={<CustomViewForm data={data} />} lead={false} view /> : <Loader />}
    </Layout>
  )
}

export default ViewLead
